import { TDialog } from '../dialog/index.types';

export type TDialogForm<T extends unknown> = {
    onSuccess?: () => void;
    onError?: () => void;
    onStart?: () => void;
    onSubmit: (arg0: T) => void;
    onCancel?: () => void;
    initValues: T;
    validate?: (arg0: T) => Partial<{ [index in keyof T]: T[index] }>;
    isConfirmationNeeded?: boolean;
    isLoading?: boolean;
    labels?: {
        submit?: string;
        confirmationText?: string;
    };
    dialogFormType?: EDialogFormTypes;
} & TDialog;

export enum EDialogFormTypes {
    Add,
    Custom,
}
